package system.single

import com.github.quillraven.fleks.*
import com.github.quillraven.fleks.World.Companion.family
import com.soywiz.korge.view.camera.*
import component.*
import io.ktor.http.*
import org.jbox2d.common.*
import utils.*

class PlayerCameraSystem(
    levelWidth: Double,
    levelHeight: Double
) : IteratingSystem(family { all(PlayerComponent) }) {

    private val leftStop = GameDimensions.V_WIDTH / 2.0
    private val rightStop = levelWidth - GameDimensions.V_WIDTH / 2.0
    private val topStop = GameDimensions.V_HEIGHT / 2.0
    private val bottomStop = levelHeight - 64 * 4

    private val low = Vec2(leftStop.toFloat(), bottomStop.toFloat())
    private val high = Vec2(rightStop.toFloat(), topStop.toFloat())
    private val temp = Vec2()

    override fun onTickEntity(entity: Entity) {
        val playerComp = entity[PlayerComponent]

//        playerComp.cameraContainer.follow(playerComp.playerMetadata.view)

//        if (playerComp.cameraContainer.cameraX < leftStop) {
//            playerComp.cameraContainer.cameraX = leftStop
//        }
//
//        if (playerComp.cameraContainer.cameraX > rightStop) {
//            playerComp.cameraContainer.cameraX = rightStop
//        }
//
//        if (playerComp.cameraContainer.cameraY < topStop) {
//            playerComp.cameraContainer.cameraY = topStop
//        }
//
//        if (playerComp.cameraContainer.cameraY > bottomStop) {
//            playerComp.cameraContainer.cameraY = bottomStop
//        }

//        val clamped = MathUtils.clamp(temp, low, high)
//        playerComp.cameraContainer.cameraX = clamped.x.toDouble()
//        playerComp.cameraContainer.cameraY = clamped.y.toDouble()

        val posX = playerComp.playerMetadata.view.x
        val posY = playerComp.playerMetadata.view.y

        playerComp.prevCameraPos.x = playerComp.cameraContainer.cameraX.toFloat()
        playerComp.prevCameraPos.y = playerComp.cameraContainer.cameraY.toFloat()

        playerComp.cameraContainer.cameraX = posX
        playerComp.cameraContainer.cameraY = posY

//        when (playerComp.direction) {
//            BodyDirection.LEFT -> {
//                moveToLeft(playerComp.cameraContainer, posX, posY)
//            }
//
//            BodyDirection.RIGHT -> {
//                moveToRight(playerComp.cameraContainer, posX, posY)
//            }
//        }
//
//        if (playerComp.cameraContainer.cameraX < playerComp.cameraContainer.width / 2.0) {
//            playerComp.cameraContainer.cameraX = playerComp.cameraContainer.width / 2.0
//        }
//
//        if (playerComp.cameraContainer.cameraX > playerComp.cameraContainer.width / 2.0) {
//            playerComp.cameraContainer.cameraX = playerComp.cameraContainer.width / 2.0
//        }

//        playerComp.cameraContainer.follow()

        playerComp.cameraContainer.cameraX = MathUtils.clamp(
            playerComp.cameraContainer.cameraX.toFloat(), leftStop.toFloat(), rightStop.toFloat()
        ).toDouble()

        playerComp.cameraContainer.cameraY = MathUtils.clamp(
            playerComp.cameraContainer.cameraY.toFloat(), topStop.toFloat(), bottomStop.toFloat()
        ).toDouble()
    }

    private fun moveToLeft(cameraContainer: CameraContainer, playerX: Double, playerY: Double) {
        val targetX = playerX - cameraContainer.width / 24.0
        val targetY = playerY - cameraContainer.height / 8.0
        val deltaX = (targetX - playerX) / 5
        val deltaY = (targetY - playerY) / 60
        cameraContainer.cameraX += deltaX
        cameraContainer.cameraY += deltaY
        if (cameraContainer.cameraX < targetX) {
            cameraContainer.cameraX = targetX
        }
        if (cameraContainer.cameraY < targetY) {
            cameraContainer.cameraY = targetY
        }
    }

    private fun moveToRight(cameraContainer: CameraContainer, playerX: Double, playerY: Double) {
        val targetX = playerX + cameraContainer.width / 24.0
        val targetY = playerY - cameraContainer.height / 8.0
        val deltaX = (targetX - playerX) / 5
        val deltaY = (targetY - playerY) / 5
        cameraContainer.cameraX += deltaX
        cameraContainer.cameraY += deltaY
        if (cameraContainer.cameraX > targetX) {
            cameraContainer.cameraX = targetX
        }
        if (cameraContainer.cameraY < targetY) {
            cameraContainer.cameraY = targetY
        }
    }
}
